import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  readonly authApi: string;
  readonly pessoaApi: string;
  readonly enderecoApi: string;
  private readonly baseApiPath = environment.baseApiPath;
  private readonly localApiPath = 'http://localhost';

  constructor() {
    if (environment.environment === 'local') {
      // Local
      // this.authApi = `${this.localApiPath}:8083`;
      // this.pessoaApi = `${this.localApiPath}:8082`;
      // this.enderecoApi = `${this.localApiPath}:8086`;
      this.authApi = `${this.baseApiPath}/dev/concessao/sisreg/api/token`;
      this.pessoaApi = `${this.baseApiPath}/dev/concessao/sisreg/api/pessoa`;
      this.enderecoApi = `${this.baseApiPath}/dev/concessao/sisreg/api/endereco`;
    } else if (environment.environment === 'prod') {
      // Produção
      this.authApi = `${this.baseApiPath}/api/token`;
      this.pessoaApi = `${this.baseApiPath}/api/pessoa`;
      this.enderecoApi = `${this.baseApiPath}/api/endereco`;
    } else {
      // Outros (Homolog, Teste..)
      this.authApi = `${this.baseApiPath}/${environment.environment}/concessao/sisreg/api/token`;
      this.pessoaApi = `${this.baseApiPath}/${environment.environment}/concessao/sisreg/api/pessoa`;
      this.enderecoApi = `${this.baseApiPath}/${environment.environment}/concessao/sisreg/api/endereco`;
    }
  }
}
